import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";

import { useIntl } from "@mnemonic/intl";
import { UrlUtils } from "@mnemonic/pure-utils";
import { extractErrorMessage } from "@mnemonic/redux-utils";

import { LoginBoxCallout } from "../../Components/Login/Layout";
import { OpenIDIcon } from "../../Components/OpenIDIcon";
import { useRequestRedirectURIOpenIDAuthorizationQuery } from "../../Redux/Service/authorizeApi";
import { commonMessages } from "../../commonMessages";
import { redirectToValidatedNextURI } from "../../utils/nextURIRedirect";
import type { TOperation } from "./utils/OperationUtils";

export interface IUAOpenIDProps {
  operation: TOperation;
  nextURI: string;
}

export const AuthorizationWithOpenID = ({ nextURI, operation }: IUAOpenIDProps) => {
  const { formatMessage } = useIntl();
  const { data, isLoading, error } = useRequestRedirectURIOpenIDAuthorizationQuery(
    {
      criteria: {
        operation,
        nextURI,
      },
    },
    { skip: !operation || !nextURI },
  );

  const errorMessage = extractErrorMessage(error);

  const { providerURI, stateID } = data?.data || {};
  return (
    <Stack>
      {errorMessage && <LoginBoxCallout type="error">{errorMessage}</LoginBoxCallout>}

      <Grid container sx={{ justifyContent: "center" }}>
        <OpenIDIcon
          sx={(theme) => ({
            display: "block",
            height: theme.spacing(12),
            marginBottom: theme.spacing(2),
            marginLeft: "auto",
            marginRight: "auto",
            width: 96,
          })}
          opacity="0.54"
        />
      </Grid>
      <Grid container sx={{ justifyContent: "flex-end" }}>
        <Button
          disabled={isLoading}
          style={{ marginRight: 8 }}
          onClick={() => void redirectToValidatedNextURI(nextURI)}
        >
          {formatMessage(commonMessages.Cancel)}
        </Button>
        <Button
          variant="contained"
          color="secondary"
          disabled={isLoading}
          onClick={() => {
            if (providerURI) {
              const base64EncodedState = UrlUtils.encodeUrlCriteria({ type: "authorization", id: stateID, nextURI });
              window.location.replace(`${providerURI}&state=${base64EncodedState}`);
            }
          }}
        >
          {formatMessage(commonMessages.Authorize)}
        </Button>
      </Grid>
    </Stack>
  );
};
